const damageTypeColors = {
  acid: '#09ff09',
  cold: '#00BFFF',
  fire: '#FF4500',
  lightning: '#0026ff',
  poison: '#c4f74e',
  thunder: '#8A2BE2',
  force: '#FF1493',
  necrotic: '#90cf80',
  radiant: '#FFFF99',
  psychic: '#BA55D3',
};

export default damageTypeColors;
